/* BWOWNIES theme – front-end behaviour (Shopify AJAX cart) */
(function () {
  'use strict';
  const CFG = window.BWOWNIES || {};
  const FREE_SHIPPING = (CFG.freeShipping || 0) / 100;
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* ignore */ } },
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  function money(cents) {
    const fmt = CFG.moneyFormat || '£{{amount}}';
    const n = (cents / 100);
    const two = n.toFixed(2), noDec = Math.round(n).toString();
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, two).replace(/<[^>]+>/g, '');
  }

  /* ---------- Mobile menu ---------- */
  const header = $('.site-header');
  $('.js-menu-toggle')?.addEventListener('click', () => header.classList.toggle('menu-open'));

  /* ---------- Carousels ---------- */
  $$('.js-carousel').forEach((carousel) => {
    const track = $('.js-track', carousel);
    const step = () => {
      const first = track.firstElementChild; if (!first) return 400;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    };
    $('.js-prev', carousel)?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('.js-next', carousel)?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- Sort variant choices numerically (Shopify keeps admin order) ---------- */
  const numOf = (s) => { const m = String(s).match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : Infinity; };
  $$('.qty__pills').forEach((wrap) => { $$('.pill', wrap).sort((a, b) => numOf(a.textContent) - numOf(b.textContent)).forEach((p) => wrap.appendChild(p)); });
  $$('.pdp__options').forEach((wrap) => { $$('.opt', wrap).sort((a, b) => numOf($('strong', a)?.textContent) - numOf($('strong', b)?.textContent)).forEach((o) => wrap.appendChild(o)); });
  $$('.bab__sizes').forEach((wrap) => { $$('.bab__size', wrap).sort((a, b) => numOf(a.textContent) - numOf(b.textContent)).forEach((o) => wrap.appendChild(o)); });

  /* ---------- Product card pills ---------- */
  $$('.product').forEach((card) => {
    const pills = $$('.pill', card), price = $('.js-price', card), add = $('.js-add', card);
    pills.forEach((pill) => pill.addEventListener('click', () => {
      pills.forEach((p) => { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
      pill.classList.add('is-active'); pill.setAttribute('aria-pressed', 'true');
      if (price) price.textContent = money(parseInt(pill.dataset.price, 10));
      if (add) { add.dataset.variant = pill.dataset.variant; add.disabled = pill.hasAttribute('data-unavailable'); }
    }));
  });

  /* ---------- Marquee ---------- */
  $$('.js-marquee').forEach((m) => { m.innerHTML += m.innerHTML; });

  /* ---------- Cart (Shopify AJAX API) ---------- */
  const cart = $('.js-cart'), overlay = $('.js-cart-overlay');
  const openCart = () => { if (!cart) return; cart.hidden = false; overlay.hidden = false; document.body.style.overflow = 'hidden'; };
  const closeCart = () => { if (!cart) return; cart.hidden = true; overlay.hidden = true; document.body.style.overflow = ''; };
  $('.js-cart-toggle')?.addEventListener('click', () => { refreshCart().then(openCart); });
  $('.js-cart-close')?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); closePopup(); } });

  let toastTimer;
  function showToast(msg) {
    const toast = $('.js-toast'); if (!toast) return;
    toast.textContent = msg; toast.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
  }

  /* Upgrade an 8-box in the bag to the 12-box (which ships free) */
  function upgradeToTwelve(item) {
    return fetch('/products/' + item.handle + '.js', { credentials: 'same-origin' }).then((r) => r.json()).then((p) => {
      const v12 = (p.variants || []).find((v) => /of 12/i.test(v.title) && v.available);
      if (!v12) throw new Error('The box of 12 is sold out right now');
      return changeItem(item.key, 0).then(() => addToCart(v12.id, item.quantity, item.properties || {}, 'Box of 12'));
    }).catch((e) => showToast(e.message));
  }

  function renderCart(data) {
    const itemsEl = $('.js-cart-items'); if (!itemsEl) return;
    itemsEl.innerHTML = '';
    data.items.forEach((item) => {
      const li = document.createElement('li'); li.className = 'cart__item';
      const props = Object.entries(item.properties || {}).filter(([, v]) => v).map(([k, v]) => k + ': ' + v).join(' · ');
      li.innerHTML = '<div><strong>' + esc(item.product_title) + '</strong><small>' + esc((item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : '') + 'Qty ' + item.quantity + (props ? ' · ' + props : '')) + '</small></div><div><span>' + money(item.final_line_price) + '</span> <button type="button" class="cart__remove" aria-label="Remove" data-key="' + esc(item.key) + '">×</button></div>';
      $('button', li).addEventListener('click', () => changeItem(item.key, 0));
      itemsEl.appendChild(li);
    });
    $('.js-cart-empty').hidden = data.items.length > 0;
    // Upsells: always-on offer hides once it's in the bag; conditional offer needs a matching item in the bag
    // and is skipped when the bag already holds something else (e.g. brownies), so "Add 2 BWOWNIES to your BITES" only shows for Bites-only bags.
    $$('.js-upsell').forEach((u) => {
      const inBag = data.items.some((i) => String(i.product_id) === u.dataset.product);
      const req = (u.dataset.requires || '').toLowerCase();
      const others = data.items.filter((i) => String(i.product_id) !== u.dataset.product);
      const ok = !req || (others.some((i) => (i.product_title || '').toLowerCase().includes(req)) && others.every((i) => (i.product_title || '').toLowerCase().includes(req)));
      u.hidden = inBag || !ok || data.items.length === 0;
    });
    $('.js-cart-total').textContent = money(data.total_price);
    $$('.js-cart-count').forEach((c) => { c.textContent = data.item_count; });
    const total = data.total_price / 100;
    const ship = $('.js-shipping');
    if (ship) {
      const eight = data.items.find((i) => /gift box of 8/i.test(i.variant_title || ''));
      if (total === 0 || !FREE_SHIPPING) { ship.textContent = ''; }
      else if (total >= FREE_SHIPPING) { ship.textContent = 'You’ve unlocked FREE shipping! 🚚'; }
      else if (eight) {
        ship.innerHTML = 'Go to 12 BWOWNIES and delivery’s free <button type="button" class="upsell__add js-upgrade">Upgrade</button>';
        $('.js-upgrade', ship).addEventListener('click', () => upgradeToTwelve(eight));
      }
      else { ship.textContent = 'Spend £' + (FREE_SHIPPING - total).toFixed(2) + ' more for free shipping'; }
    }
  }
  function refreshCart() { return fetch(CFG.cartUrl + '.js', { credentials: 'same-origin' }).then((r) => r.json()).then((d) => { renderCart(d); return d; }); }
  function changeItem(key, qty) { return fetch(CFG.cartChangeUrl + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then((r) => r.json()).then(renderCart); }
  function addToCart(variantId, qty, properties, name) {
    return fetch(CFG.cartAddUrl + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1, properties: properties || {} }) })
      .then((r) => { if (!r.ok) return r.json().then((e) => { throw new Error(e.description || e.message || 'Could not add to cart'); }); return r.json(); })
      .then(() => refreshCart()).then(() => { showToast('Added ' + (name || 'item') + ' to your bag 🎉'); openCart(); })
      .catch((e) => showToast(e.message));
  }
  $$('.js-add').forEach((btn) => btn.addEventListener('click', () => addToCart(btn.dataset.variant, 1, {}, btn.dataset.name)));
  $$('.js-upsell-add').forEach((btn) => btn.addEventListener('click', () => { const u = btn.closest('.js-upsell'); addToCart(u.dataset.variant, 1, {}, u.dataset.name); }));

  /* ---------- Product page / featured product buy box ---------- */
  const gallery = $('.js-gallery');
  if (gallery) {
    const mains = $$('.pdp__main > *', gallery), thumbs = $$('.pdp__thumb', gallery);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      mains.forEach((m) => m.classList.toggle('is-active', m.dataset.index === t.dataset.index));
      thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
    }));
  }
  $$('.js-buy').forEach((box) => {
    const options = $('.js-options', box); if (!options) return;
    const inputs = $$('input[type="radio"]', options);
    const addBtn = $('.js-pdp-add', box);
    inputs.forEach((inp) => inp.addEventListener('change', () => {
      $$('.opt', options).forEach((o) => o.classList.toggle('is-active', $('input', o) === inp));
      const p = parseInt(inp.dataset.price, 10);
      const priceEl = $('.js-pdp-price', box); if (priceEl) priceEl.textContent = money(p);
      const btnPrice = $('.js-pdp-price-btn', box); if (btnPrice) btnPrice.textContent = money(p);
      const per = $('.js-per', box); if (per) { per.textContent = inp.dataset.per ? (/shipping/i.test(inp.dataset.per) ? '' : 'Just ') + inp.dataset.per : ''; per.hidden = !inp.dataset.per; }
      if (addBtn) addBtn.disabled = inp.dataset.available === 'false';
    }));
    const giftBox = $('.js-gift', box), giftMsg = $('.js-gift-msg', box);
    giftBox?.addEventListener('change', () => { giftMsg.hidden = !giftBox.checked; if (giftBox.checked) giftMsg.focus(); });
    addBtn?.addEventListener('click', () => {
      const sel = inputs.find((i) => i.checked); if (!sel) return;
      const props = {}; if (giftBox && giftBox.checked && giftMsg.value) props['Gift message'] = giftMsg.value;
      addToCart(sel.value, 1, props, addBtn.dataset.name);
    });
  });
  $$('.js-faq').forEach((q) => q.addEventListener('click', () => {
    const open = q.getAttribute('aria-expanded') === 'true';
    q.setAttribute('aria-expanded', String(!open)); q.nextElementSibling.hidden = open;
  }));
  (function countdown() {
    const els = $$('.js-countdown'); if (!els.length) return;
    const dateEls = $$('.js-delivery-date');
    const ordinal = (n) => n + (['th', 'st', 'nd', 'rd'][(n % 100 > 10 && n % 100 < 14) ? 0 : Math.min(n % 10, 4) % 4] || 'th');
    const fmt = (d) => d.toLocaleDateString('en-GB', { weekday: 'long' }) + ' ' + ordinal(d.getDate()) + ' ' + d.toLocaleDateString('en-GB', { month: 'long' });
    function nextCutoff() { const d = new Date(); d.setHours(12, 0, 0, 0); if (d <= new Date()) d.setDate(d.getDate() + 1); while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1); return d; }
    function tick() {
      const cutoff = nextCutoff(); const mins = Math.max(0, Math.round((cutoff - new Date()) / 60000));
      const h = Math.floor(mins / 60), m = mins % 60;
      els.forEach((e) => { e.textContent = (h > 0 ? h + ' hr' + (h === 1 ? ' ' : 's ') : '') + m + ' min' + (m === 1 ? '' : 's'); });
      const del = new Date(cutoff); let add = 2; while (add > 0) { del.setDate(del.getDate() + 1); if (del.getDay() !== 0 && del.getDay() !== 6) add--; }
      dateEls.forEach((e) => { e.textContent = fmt(del); });
    }
    tick(); setInterval(tick, 30000);
  })();

  /* ---------- Build a box ---------- */
  const bab = $('.js-bab');
  if (bab) {
    const counts = {}; const cards = $$('.bab__card', bab);
    const sel = () => $('input[name="boxsize"]:checked', bab);
    const size = () => parseInt(sel().value, 10), price = () => parseInt(sel().dataset.price, 10);
    const total = () => Object.values(counts).reduce((a, b) => a + b, 0);
    function render() {
      const n = size(), t = total();
      $('.js-bab-total').textContent = t;
      cards.forEach((c) => { $('.js-bab-count', c).textContent = counts[c.dataset.flavour] || 0; c.classList.toggle('is-max', t >= n); });
      const slots = $('.js-bab-slots'); slots.innerHTML = '';
      const chosen = []; cards.forEach((c) => { for (let i = 0; i < (counts[c.dataset.flavour] || 0); i++) chosen.push($('img', c).currentSrc || $('img', c).src); });
      for (let i = 0; i < n; i++) { const s = document.createElement('div'); s.className = 'bab__slot'; if (chosen[i]) s.innerHTML = '<img src="' + chosen[i] + '" alt="">'; slots.appendChild(s); }
      const btn = $('.js-bab-add'); btn.disabled = t !== n;
      btn.textContent = t === n ? 'Add to Cart - ' + money(price()) : t < n ? 'Add ' + (n - t) + ' more flavour' + (n - t === 1 ? '' : 's') : 'Remove ' + (t - n) + ' flavour' + (t - n === 1 ? '' : 's');
    }
    cards.forEach((c) => {
      const f = c.dataset.flavour;
      $('.js-bab-plus', c).addEventListener('click', () => { if (total() < size()) { counts[f] = (counts[f] || 0) + 1; render(); } });
      $('.js-bab-minus', c).addEventListener('click', () => { if (counts[f] > 0) { counts[f]--; render(); } });
    });
    $$('input[name="boxsize"]', bab).forEach((i) => i.addEventListener('change', () => {
      $$('.bab__size', bab).forEach((s) => s.classList.toggle('is-active', $('input', s) === i));
      while (total() > size()) { const k = Object.keys(counts).find((x) => counts[x] > 0); counts[k]--; }
      render();
    }));
    $('.js-bab-surprise').addEventListener('click', () => {
      Object.keys(counts).forEach((k) => delete counts[k]);
      for (let i = 0; i < size(); i++) { const c = cards[Math.floor(Math.random() * cards.length)].dataset.flavour; counts[c] = (counts[c] || 0) + 1; }
      render();
    });
    $('.js-bab-add').addEventListener('click', () => {
      const desc = cards.filter((c) => counts[c.dataset.flavour]).map((c) => counts[c.dataset.flavour] + '× ' + c.dataset.flavour).join(', ');
      addToCart(sel().dataset.variant, 1, { Flavours: desc }, 'Build your own box');
    });
    render();
  }

  /* ---------- About story carousel ---------- */
  const story = $('.js-story');
  if (story) {
    const slides = $$('.story__slide', story), caps = $$('.story__cap', story), track = $('.js-story-track', story);
    let idx = 1;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      caps.forEach((c, i) => c.classList.toggle('is-active', i === idx));
      const w = slides[0].getBoundingClientRect().width + 40;
      const center = track.parentElement.getBoundingClientRect().width / 2 - w / 2;
      track.style.transform = 'translateX(' + (center - idx * w) + 'px)'; track.style.justifyContent = 'flex-start';
    }
    $('.js-story-prev', story).addEventListener('click', () => go(idx - 1));
    $('.js-story-next', story).addEventListener('click', () => go(idx + 1));
    window.addEventListener('resize', () => go(idx));
    go(0);
  }

  /* ---------- Country selector (localization form) ---------- */
  const country = $('.js-country');
  if (country) {
    const btn = $('.js-country-btn', country), list = $('.js-country-list', country);
    btn.addEventListener('click', () => { list.hidden = !list.hidden; btn.setAttribute('aria-expanded', String(!list.hidden)); });
    $$('.country__opt', country).forEach((o) => o.addEventListener('click', () => { $('input[name="country_code"]', country).value = o.dataset.value; country.submit(); }));
    document.addEventListener('click', (e) => { if (!country.contains(e.target)) list.hidden = true; });
  }

  /* ---------- Email popup ---------- */
  const popup = $('.js-popup');
  function closePopup() { if (popup && !popup.hidden) { popup.hidden = true; store.set('bwownies-popup', true); } }
  if (popup && !store.get('bwownies-popup', false) && !window.Shopify?.designMode) {
    setTimeout(() => { popup.hidden = false; }, 2500);
    $$('.js-popup-close', popup).forEach((b) => b.addEventListener('click', closePopup));
    $('.js-popup-form', popup)?.addEventListener('submit', () => store.set('bwownies-popup', true));
  }

  refreshCart();
})();